/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type TypeOfPlace = "agglomeration" | "country" | "district" | "locality" | "municipality" | "neighbourhood" | "postcode" | "region" | "state";
import type { FragmentReference } from "relay-runtime";
declare export opaque type useAggregatesListingsPlaceData_aggregatesListings$ref: FragmentReference;
declare export opaque type useAggregatesListingsPlaceData_aggregatesListings$fragmentType: useAggregatesListingsPlaceData_aggregatesListings$ref;
export type useAggregatesListingsPlaceData_aggregatesListings = {|
  +filters: {|
    +places: ?$ReadOnlyArray<{|
      +slugEn: string,
      +type: TypeOfPlace,
      +label: string,
      +inLabel: string,
      +indexRooms: boolean,
    |}>
  |},
  +$refType: useAggregatesListingsPlaceData_aggregatesListings$ref,
|};
export type useAggregatesListingsPlaceData_aggregatesListings$data = useAggregatesListingsPlaceData_aggregatesListings;
export type useAggregatesListingsPlaceData_aggregatesListings$key = {
  +$data?: useAggregatesListingsPlaceData_aggregatesListings$data,
  +$fragmentRefs: useAggregatesListingsPlaceData_aggregatesListings$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAggregatesListingsPlaceData_aggregatesListings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatesListingFilters",
      "kind": "LinkedField",
      "name": "filters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Place",
          "kind": "LinkedField",
          "name": "places",
          "plural": true,
          "selections": [
            {
              "alias": "slugEn",
              "args": [
                {
                  "kind": "Literal",
                  "name": "lang",
                  "value": "en"
                }
              ],
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": "slug(lang:\"en\")"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "inLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "indexRooms",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AggregatesListingConnectionConnection",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '7a8ea9506a0c36f75a1816280d2c9c79';

export default node;
